<div class="flex">
  <!-- Sidebar estilo Wink Design System (back office): panel claro elevado,
       items fantasma con hover sutil y estado activo en brand-subtle -->
  <nav
    class="pt-8 px-3 bg-surface-elevated border-r border-border-subtle w-[69px] hover:w-72 transition-all duration-200 flex flex-col fixed h-full z-50 rounded-r-2xl group overflow-hidden"
  >
    <button
      (click)="setFilter('all')"
      [ngClass]="
        selectedFilter === 'all'
          ? 'bg-surface-brand-subtle text-text-brand font-semibold shadow-sm'
          : 'text-text-secondary hover:bg-surface-subtle hover:text-text-primary'
      "
      class="flex items-center pl-2.5 mb-2 h-12 rounded-xl w-full font-medium nav-btn"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        width="25"
        height="21"
        viewBox="0 0 25 21"
        class="shrink-0"
      >
        <path
          d="M22.5 5.5H17.5V6.75H22.5C23.1891 6.75 23.75 7.31094 23.75 8V15.5C23.75 16.1891 23.1891 16.75 22.5 16.75H20V18.6863L16.5781 16.75H12.5C11.8109 16.75 11.25 16.1891 11.25 15.5V14.25L10 14.2498V15.4991C10 16.876 11.123 17.9639 12.4648 17.9639L16.25 18L20.5039 20.4074C20.5898 20.4727 20.6875 20.5 20.7812 20.5C21.0273 20.5 21.25 20.3086 21.25 20.0312V17.9988H22.5C23.877 17.9988 25 16.8758 25 15.534V7.96484C25 6.62109 23.8789 5.5 22.5 5.5ZM16.25 10.5V2.96484C16.25 1.62305 15.1289 0.5 13.75 0.5H2.5C1.12305 0.5 0 1.62305 0 2.96484V10.4648C0 11.8789 1.12305 13 2.5 13L3.75 13.0004V15.0312C3.75 15.3086 3.97656 15.5 4.21875 15.5C4.31152 15.5 4.40918 15.4707 4.49707 15.4072L8.75 13L13.75 12.9971C15.1289 12.9961 16.25 11.8789 16.25 10.5ZM8.42188 11.75L5 13.6875V11.75H2.5C1.81094 11.75 1.25 11.1875 1.25 10.5V3C1.25 2.31094 1.81094 1.75 2.5 1.75H13.75C14.4391 1.75 15 2.31094 15 3V10.5C15 11.1891 14.4391 11.75 13.75 11.75H8.42188Z"
        />
      </svg>
      <span class="ml-4 nav-label">Todos los chats</span>
    </button>
    <button
      (click)="setFilter('1')"
      [ngClass]="
        selectedFilter === '1'
          ? 'bg-surface-brand-subtle text-text-brand font-semibold shadow-sm'
          : 'text-text-secondary hover:bg-surface-subtle hover:text-text-primary'
      "
      class="flex items-center pl-[13px] mb-2 h-12 rounded-xl w-full font-medium nav-btn"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        width="25"
        height="21"
        viewBox="0 0 25 21"
        class="shrink-0"
      >
        <path
          d="M9.48828 4.25H9.51323C10.9878 4.25 12.3246 5.11328 12.9285 6.46211C13.5292 7.81484 13.2793 9.40469 12.2882 10.4973C12.2882 10.4924 12.2882 10.5021 12.2882 10.4973L12.625 10.5C13.2695 10.5 13.8711 10.1641 14.2078 9.61719C14.3828 9.10938 14.5 8.57031 14.5 8C14.5 5.23633 12.2637 3 9.5 3C6.73633 3 4.5 5.23633 4.5 8C4.5 9.57734 5.24687 10.9684 6.38945 11.8863C6.38281 11.8359 6.375 11.8008 6.375 11.75C6.37891 11.3125 6.49609 10.875 6.72266 10.5C5.72656 9.40625 5.46758 7.82422 6.06836 6.46484C6.67187 5.11719 8.00781 4.25 9.48828 4.25ZM2.625 9.25C2.97187 9.25 3.25 8.97266 3.25 8.625V8C3.25 4.55273 6.05273 1.75 9.5 1.75C12.9473 1.75 15.75 4.55273 15.75 8V8.625C15.75 10.3477 14.3477 11.75 12.625 11.75H11.375C11.375 11.0617 10.8133 10.5 10.125 10.5H8.875C8.18672 10.5 7.625 11.0617 7.625 11.75C7.625 12.4383 8.18672 13 8.875 13H12.625C15.0422 12.9951 16.9961 11.0418 17 8.625V8C17 3.86328 13.6355 0.5 9.5 0.5C5.36445 0.5 2 3.86445 2 8V8.625C2 8.97266 2.27852 9.25 2.625 9.25ZM13.043 14.25H5.95703C3.08203 14.25 0.75 16.582 0.75 19.457C0.75 20.0352 1.21641 20.5 1.79141 20.5H17.207C17.7852 20.5 18.25 20.0352 18.25 19.457C18.25 16.582 15.918 14.25 13.043 14.25ZM2.00547 19.25C2.11402 17.1637 3.8457 15.5 5.95859 15.5H13.0406C15.1535 15.5 16.8852 17.1637 16.9937 19.25H2.00547Z"
        />
      </svg>
      <span class="ml-3.5 flex gap-2.5 nav-label"
        >Necesitan asistencia
        <button class="btnCount">{{ totalAssistanceRequired }}</button></span
      >
    </button>
    <button
      (click)="setFilter('0')"
      [ngClass]="
        selectedFilter === '0'
          ? 'bg-surface-brand-subtle text-text-brand font-semibold shadow-sm'
          : 'text-text-secondary hover:bg-surface-subtle hover:text-text-primary'
      "
      class="flex items-center pl-2.5 mb-2 h-12 rounded-xl w-full font-medium nav-btn"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        width="25"
        height="21"
        viewBox="0 0 25 21"
        class="shrink-0"
      >
        <path
          d="M23.75 6.71484C23.0137 6.71484 22.7562 7.23477 22.6941 7.33984H21.25V2.99961C21.25 1.62305 20.1289 0.5 18.75 0.5H6.25C4.875 0.5 3.75 1.62305 3.75 2.99961V7.37461H2.30586C2.24375 7.26953 1.98633 6.71484 1.25 6.71484C0.535156 6.71484 0 7.29961 0 7.96484C0 8.63125 0.535937 9.17969 1.25 9.17969C1.98633 9.17969 2.24336 8.66016 2.30586 8.58984H3.75V14.1797C3.75 15.5566 4.87305 16.6445 6.25 16.6445L8.75 16.6449V19.9258C8.75 20.3086 8.97656 20.5 9.21875 20.5C9.31258 20.5 9.40805 20.4726 9.49594 20.4091L14.375 16.7148L18.75 16.7145C20.127 16.7145 21.25 15.5914 21.25 14.2496V8.58984H22.6945C22.7578 8.73047 23.0156 9.21484 23.75 9.21484C24.4648 9.21484 25 8.63047 25 8C25 7.33203 24.4648 6.71484 23.75 6.71484ZM20 14.2148C20 14.9023 19.4375 15.4297 18.75 15.4297H14.3711C14.1005 15.4297 13.8371 15.5174 13.6207 15.6798L10 18.4336V16.125C10 15.7798 9.72016 15.5352 9.375 15.5352H6.25C5.5625 15.5352 5 14.9727 5 14.3203V11.75H20V14.2148ZM20 10.5H5V5.5H20V10.5ZM20 4.25H5V2.99961C5 2.31211 5.5625 1.78477 6.25 1.78477H18.75C19.4375 1.78477 20 2.34727 20 2.99961V4.25ZM8.75 9.21484C9.44023 9.21484 10 8.65508 10 7.96484C10 7.27461 9.44023 6.71484 8.75 6.71484C8.05977 6.71484 7.5 7.27461 7.5 7.96484C7.5 8.69141 8.05859 9.21484 8.75 9.21484ZM16.25 9.21484C16.9402 9.21484 17.5 8.65508 17.5 7.96484C17.5 7.27461 16.9402 6.71484 16.25 6.71484C15.5598 6.71484 15 7.27461 15 7.96484C15 8.69141 15.5586 9.21484 16.25 9.21484Z"
        />
      </svg>
      <span class="ml-4 nav-label"
        >No requieren asistencia</span
      >
    </button>
    <div class="mt-auto">
      <button
        (click)="toggleTheme()"
        class="flex items-center pl-[13px] mb-8 h-12 rounded-xl w-full font-medium text-text-secondary hover:bg-surface-subtle hover:text-text-primary nav-btn"
      >
        <!-- Sol de rayos (Bootstrap Icons brightness-high, MIT), escalado a la
             misma caja 20x20 del icono de luna para que ambos hagan pareja -->
        <svg
          *ngIf="isDarkMode()"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          width="25"
          height="21"
          viewBox="0 0 25 21"
          class="shrink-0"
        >
          <path
            transform="translate(0 0.5) scale(1.25)"
            d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
          />
        </svg>
        <svg
          *ngIf="!isDarkMode()"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          width="25"
          height="21"
          viewBox="0 0 25 21"
          class="shrink-0"
        >
          <path
            d="M12.582 16.1797L12.3989 16.1943C12.1023 16.2529 11.797 16.2822 11.4942 16.2822C8.87703 16.2822 6.74813 14.1471 6.74813 11.5244C6.74813 9.81543 7.67234 8.22832 9.15906 7.37988C9.50391 7.17969 9.6875 6.79688 9.62109 6.39844C9.55078 6 9.25781 5.69922 8.83203 5.62891C8.41016 5.54297 7.9375 5.46484 7.48828 5.46484C3.35625 5.46484 0 8.86328 0 13C0 17.1367 3.35977 20.5 7.49219 20.5C9.76523 20.5 11.8906 19.4828 13.3086 17.725C13.5454 17.4418 13.5928 17.0613 13.4365 16.7281C13.2812 16.3945 12.9453 16.1797 12.582 16.1797ZM7.49219 19.25C4.05078 19.25 1.25 16.4453 1.25 13C1.25 9.55469 4.05039 6.75 7.49219 6.75C7.60695 6.75 7.72289 6.75366 7.83887 6.75977C6.37891 7.89062 5.49609 9.64844 5.49609 11.5234C5.49609 14.8375 8.18672 17.5312 11.4922 17.5312C11.5947 17.5312 11.6973 17.5288 11.7986 17.5239C10.6484 18.6289 9.11719 19.25 7.49219 19.25ZM19.375 8.625H18.125V7.375C18.125 7.03125 17.8438 6.75 17.5 6.75C17.1562 6.75 16.875 7.02953 16.875 7.375V8.625H15.625C15.2812 8.625 15 8.90625 15 9.25C15 9.59375 15.2795 9.875 15.625 9.875H16.875V11.125C16.875 11.4688 17.1562 11.75 17.5 11.75C17.8438 11.75 18.125 11.4705 18.125 11.125V9.875H19.375C19.7188 9.875 20 9.59375 20 9.25C20 8.90625 19.7188 8.625 19.375 8.625ZM16.875 4.25C16.875 3.90453 16.5955 3.625 16.25 3.625H13.75V1.125C13.75 0.779531 13.4688 0.5 13.125 0.5C12.7812 0.5 12.5 0.779531 12.5 1.125V3.625H10C9.65625 3.625 9.375 3.90469 9.375 4.25C9.375 4.59531 9.65625 4.875 10 4.875H12.5V7.375C12.5 7.71875 12.7812 8 13.125 8C13.4688 8 13.75 7.71875 13.75 7.375V4.875H16.25C16.5938 4.875 16.875 4.59375 16.875 4.25Z"
          />
        </svg>
        <span class="ml-4 nav-label"
          >Modo de {{ isDarkMode() ? "día" : "noche" }}</span
        >
      </button>
    </div>
  </nav>
</div>
